<template>
  <div>
    <i
      id="popover-target-1"
      class="las la-exclamation-circle fs-1600 text-info"
    ></i>
    <b-popover target="popover-target-1" triggers="hover" placement="top">
      <template #title><span class="fs-900 fw-600">Commissions</span></template>
      <p>
        Default brokerage:
        <span class="fw-600">{{ defaultBrokerage }}</span>
      </p>
      <p>
        Default VSA brokerage:
        <span class="fw-600">{{ defaultVsaBrokerage }}</span>
      </p>
      <p>
        Default dealer brokerage:
        <span class="fw-600">{{ defaultDealerBrokerage }}</span>
      </p>
      <hr />
      <p>
        Dealer quoted brokerage:
        <span class="fw-600">{{ dealerBrokerage }}</span>
      </p>
      <p>
        VSA new brokerage: <span class="fw-600">{{ brokerageVSA }}</span>
      </p>
      <p>
        Ref. partner brokerage:
        <span class="fw-600">{{ reportingBrokerage }}</span>
      </p>
    </b-popover>
  </div>
</template>
<script>
export default {
  name: 'WDPopCommissions',
  props: {
    defaultBrokerage: {
      type: String,
      default: ''
    },
    defaultVsaBrokerage: {
      type: String,
      default: ''
    },
    defaultDealerBrokerage: {
      type: String,
      default: ''
    },
    dealerBrokerage: {
      type: String,
      default: ''
    },
    brokerageVSA: {
      type: String,
      default: ''
    },
    reportingBrokerage: {
      type: String,
      default: ''
    }
  },
  methods: {}
}
</script>

defaultBrokerage: -1, //This is total brokerage dealer and vsa can take it. It
is 0.1, vsa brokerage:0.05 and dealer can get max 0.05 (0.05 + 0.05 = 0.1 0.1)
defaultVsaBrokerage: -1, // which is VSA default brokerage Eg.0.5 in lookup
table defaultDealerBrokerage: -1, // which is added on Dealer table and on new
Dealer create dealerBrokerage: -1, // which is added by Dealer on Submit new
quote newVsaBrokerage: -1, // which VSA Brokerage after adjust dealer default
brokerage Eg. (0.1 - default dealer brokerage) reportingBrokerage: -1 // which
is referral partner brokerage on create new referral partner
